import { render, staticRenderFns } from "./pv-edit.vue?vue&type=template&id=401817c7&lang=pug&"
import script from "./pv-edit.vue?vue&type=script&lang=js&"
export * from "./pv-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports